<template>
	<div class="wc-header">
		<div class="checkout-wrapper">
			<div class="wc-header-intro">
				<BaseCmsLogo class="logo wc-logo" id="logo" />
				<BaseCmsLabel code="header_contact" class="wc-header-tel" tag="div" />
			</div>
			
			<div class="ch-step-progressbar-container">
				<BaseCmsLabel code="checkout_progressbar_title" class="ch-step-progressbar-title" tag="div" />
				<div class="free-delivery-missing">
					<div class="free-delivery-missing-bg-cnt">
						<span class="free-delivery-missing-bg" :style="'width:'+progress"></span>
					</div>
					<span class="free-delivery-missing-overlay"></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	const props = defineProps({
		step: Number,
	});
	const progress = computed(() => {
		if (props.step === 1) return '23.5%';
		if (props.step === 2) return '39.5%';
		if (props.step === 3) return '59%';
		if (props.step === 4) return '75%';
		if (props.step === 5) return '96.5%';
	});
</script>

<style lang="less" scoped>
	.wc-header{
		min-height: 95px; background: white; z-index: 99; position: relative; border-bottom: 1px solid var(--borderColor);
		.checkout-wrapper{position: relative; display: flex; align-items: center; justify-content: space-between; min-height: 95px; width: 1220px; margin: 0 auto;}
		@media (max-width: @t){
			min-height: 90px;
			.checkout-wrapper{min-height: 90px; margin: 0 50px; width: auto;}
		}
		@media (max-width: @tp){
			min-height: 65px;
			.checkout-wrapper{min-height: 65px; margin: 0 15px;}
		}
		@media (max-width: @m){
			min-height: unset; border-bottom: unset;
			.checkout-wrapper{min-height: unset; padding: 8px 0 0 0;}
		}
	}
	.wc-header-intro{
		display: flex; align-items: center;justify-content: space-between; width: calc(~"50% - 110px");
		@media (max-width: @t){width: calc(~"50% - 30px");}
		@media (max-width: @tp){width: calc(~"50% - 15px");}
		@media (max-width: @m){width: auto;}
	}
	.wc-logo{
		width: 85px; height: 72px; margin: 0; position: static; left: 0;
		@media (max-width: @t){margin: 0; width: 78px; height: 65px; top: 14px;}
		@media (max-width: @tp){margin: 0; width: 50px; height: 42px; top: 9px;}
		@media (max-width: @m){margin: 0;}
	}
	.wc-header-tel{
		font-size: 0; line-height: 0;
		:deep(a){display: none;}
		:deep(a[href^=tel]){
			display: block !important; font-size: 18px !important; line-height: 24px !important; text-decoration: none; position: relative; color: var(--textColor); padding-left: 30px;
			&:before{.pseudo(auto,auto); .icon-phone; font: 20px/20px var(--fonti); left: 0; top: 1px; color: var(--primaryColor);}
			@media(min-width: @h){
				&:hover{color: var(--primaryColor);}
			}
		}
		@media (max-width: @t){
			:deep(a[href^=tel]){
				font-size: 16px !important; line-height: 22px !important;
				&:before{font: 18px/18px var(--fonti); top: 0;}
			}
		}
		@media (max-width: @tp){display: none;}
	}

	.ch-step-progressbar-container{
		position: relative; display: flex; width: auto; align-items: center; flex-shrink: 0; width: calc(~"50% - 110px");
		.free-delivery-missing-bg-cnt{margin-right: 0;}
		.free-delivery-missing:after{display: none;}
		.free-delivery-missing-overlay{right: 20px; left: 15px;}
		@media (max-width: @t){
			width: calc(~"50% - 30px");
			.free-delivery-missing{height: 40px;}
		}
		@media (max-width: @tp){
			width: calc(~"50% - 15px");
			.free-delivery-missing{height: 22px; padding: 0 5px;}
			.free-delivery-missing-bg{height: 14px; background-size: 9px;}
			.free-delivery-missing-overlay{right: 3px; left: 5px; background-size: 9px; height: 14px;}
		}
		@media (max-width: @m){width: auto; flex-grow: 1; margin-left: 22px;}
	}
	.ch-step-progressbar-title{
		display: block; font-size: 16px; line-height: 22px; font-weight: bold; padding-right: 26px; padding-top: 0; padding-bottom: 0; white-space: nowrap;
		@media (max-width: @t){font-size: 14px; line-height: 20px; padding-right: 18px;}
		@media (max-width: @tp){font-size: 14px; line-height: 20px; padding-right: 12px;}
		@media (max-width: @m){display: none;}
	}
</style>
